<template>
<div>
	<div class="container">
		<!-- <footer-s></footer-s> -->
		<loginHeader></loginHeader>
		<div class="about">
			<img src="../../assets/img/join-b.jpg" class="about-sign" />
			<div class="company">
				<div class="company-list">
					<h1>合作加盟</h1>
					<p>请点击以下的申请表格，填写资料提交后，我们的工作人员在三个工作日内将会联系您，并提供相应的指引。</p>
				
						<div class="company-list">
							<a href="/File/酒店合作申请表.xls">
								<div class="company-contact join-box">

									<div class="left">
										<img src="../../assets/img/download.png" />
									</div>
									<div class="mail-phone">
										<h1>酒店合作申请表 </h1>
									</div>
								</div>
							</a>
                            <a href="/File/供应商合作申请表.xls">
                                <div class="company-contact join-box">
                                    <div class="left">
                                        <img src="../../assets/img/download.png"/>
                                    </div>
                                    <div class="mail-phone">
                                        <h1>供应商合作申请表 </h1>
                                    </div>
                                </div>
                             </a>
                            <a href="/File/龙腾捷旅供应商协议书.doc">
                                <div class="company-contact join-box">
                                    <div class="left">
                                        <img src="../../assets/img/download.png" />
                                    </div>
                                    <div class="mail-phone">
                                        <h1>合作协议书 </h1>
                                    </div>
                                </div>
                                </a>
                        </div>
					</div>
				

				<div class="company-list">
					<h1>联系方式</h1>
					<div class="company-contact">
						<div class="left">
							香港<br/>
							产品
						</div>
						<div class="right">
							<h1>电话：0755-2134 9709</h1>
							<h1>邮箱：cntravel@163.com</h1>
						</div>
					</div>

					<div class="company-contact">
						<div class="left">
							国内<br />
							产品
						</div>
						<div class="right">
							<h1>电话：0755-8230 0733</h1>
							<h1>邮箱：chinahotel-1@cnbooking.net</h1>
						</div>
					</div>


					<div class="company-contact">
						<div class="left">
							澳门<br />
							产品
						</div>
						<div class="right">
							<h1>电话：18688180108 </h1>
							<h1>邮箱：macauhotel-1@cnbooking.net</h1>
						</div>
					</div>


					<div class="company-contact">
						<div class="left">
							海外<br />
							产品
						</div>
						<div class="right">
							<h1>电话：0755-8231 5164</h1>
							<h1>邮箱：globalhotel-33@cnbooking.net</h1>
						</div>
					</div>


					<div class="company-contact">
						<div class="left">
							集团<br />
							产品
						</div>
						<div class="right"> 
							<h1>电话：0755-2221 4434</h1>
							<h1>邮箱：chinahotel-2@cnbooking.net</h1>
						</div>
					</div>


					<div class="company-contact">
						<div class="left">
							同业<br />
              产品
						</div>
						<div class="right">
							<h1>电话：0755-8231 1941</h1>
							<h1>邮箱：chinahotel-3@cnbooking.net</h1>
						</div>
					</div>
				</div>

				<div class="company-list">
					<h1>合作伙伴</h1>
					<p>排名不分先后，版面有限不一一列举</p>
					<img src="../../assets/img/cn018.jpg"  class="hotel-list-logos"/>
				</div>

			</div>
			


		</div>

		<div class="home-footer">
			<div class="home-box home-footer-t">
				<div class="top">
					<div class="left home-contact">
						<h3>了解我们</h3>
						<router-link to="about">关于我们</router-link>
						<router-link to="contact">联系我们</router-link>
						<router-link to="contact">投诉建议</router-link>
						<router-link to="join">诚聘英才</router-link>
						
					</div>
					<div class="middle home-contact">
						<h3>客户须知</h3>
						<router-link to="introduction">预订须知</router-link>
						<router-link to="introduction">协议下载</router-link>
						<router-link to="introduction">教程下载</router-link>
					</div>
					<div class="right home-contact">
						<h3>邮箱地址</h3>
						<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
					</div>
					<div class="right-side home-contact">
						<h3>微信二维码</h3>
						<img src="./../../assets/img/ewm.png" alt="" />
					</div>
					<div class="clear"></div>
				</div>
				<div class="bottom">
					<img src="./../../assets/img/home-footer-logo.png" alt="" />
					<div>
						<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
						<h4>
							<a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
							<a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
								<img src="./../../assets/img/ga.png" />
								    粤公网安备 44030302000423号
							</a>
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
	import loginHeader from '../loginHeader.vue'
	export default {
        components: { FooterS,loginHeader },
	}
</script>


// WEBPACK FOOTER //
// src/components/info/cooperation.vue